"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef } from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { LoadingState } from "./types";
export function useWaveLoadingState() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const loadingStates = useRef(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = waveId => {
      const loadingState = loadingStates.current[waveId] ?? {
        isLoading: false,
        promise: null
      };
      loadingStates.current[waveId] = loadingState;
      const shouldContinue = !(loadingState.isLoading && loadingState.promise);
      return {
        state: loadingState,
        shouldContinue
      };
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getLoadingState = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (waveId_0, isLoading) => {
      if (loadingStates.current[waveId_0]) {
        loadingStates.current[waveId_0].isLoading = isLoading;
        if (!isLoading) {
          loadingStates.current[waveId_0].promise = null;
        }
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setLoadingState = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (waveId_1, promise) => {
      if (loadingStates.current[waveId_1]) {
        loadingStates.current[waveId_1].promise = promise;
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const setPromise = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = waveId_2 => {
      if (loadingStates.current[waveId_2]) {
        loadingStates.current[waveId_2].isLoading = false;
        loadingStates.current[waveId_2].promise = null;
      }
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const clearLoadingState = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      getLoadingState,
      setLoadingState,
      setPromise,
      clearLoadingState,
      loadingStates
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}